import { ThemeUICSSObject, spacing } from '@apia/theme';

const grids: Record<string, ThemeUICSSObject> = {
  default: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridColumnGap: '1em',
    gridRowGap: '1em',
    width: '100%',
    height: '100%',
  },
  general: {
    'layout-12-cols': {
      variant: 'grids.default',
    },
    'layout-8-cols': {
      variant: 'grids.default',
      gridTemplateColumns: 'repeat(8, 1fr)',
    },
    'layout-4-cols': {
      variant: 'grids.default',
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
  execution: {
    form: {
      display: 'grid',
      alignItems: 'start',
      justifyContent: 'start',
      gridAutoRows: 'minmax(0, auto)',
      gap: 0,

      '& > *': {
        p: spacing(5),
      },
    },
    formReadOnly: {
      gap: 0,

      '& > *': {
        p: spacing(5),
      },
      alignItems: 'start',
      gridAutoRows: 'minmax(0, auto)',
    },
  },
};

export default grids;
